/**
 * SeriesPageV2 — redesigned Series list shell, port of the prototype's
 * `.screen-series` page-head (cms-redesign-mockup.html ~6380–6413).
 *
 * Single header action: "+ New Series" (coral). Series doesn't have a
 * stand-alone in-app intro field like Quick Taps / Challenges, so the
 * header stays lean. The body (SeriesTableV2) carries its own status
 * filter + view toggle in a toolbar.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SeriesTableV2 from '../../SeriesTable/v2/SeriesTableV2';
import { PageHeader, Button } from '../../redesign';

const PlusSign = (
  <span style={{ fontSize: 16, lineHeight: 1 }} aria-hidden>+</span>
);

export default function SeriesPageV2() {
  const total = useSelector((s) =>
    Array.isArray(s.series.all_series) ? s.series.all_series.length : undefined,
  );
  const totalLabel = total != null ? `${total.toLocaleString()} items` : undefined;

  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Content Library"
        title="Series"
        total={totalLabel}
        actions={
          <Link to="/series/add" className="no-underline">
            <Button variant="coral" leadingIcon={PlusSign}>
              New Series
            </Button>
          </Link>
        }
      />
      <SeriesTableV2 />
    </div>
  );
}
